import React, { useState } from 'react';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import { ThemeProvider } from '@/context/ThemeContext';
import { Layout } from '@/components/layout/Layout';
import { LoginPage } from '@/pages/LoginPage';
import { Dashboard } from '@/pages/Dashboard';
import { Products } from '@/pages/Products';
import { Customers } from '@/pages/Customers';
import { Invoices } from '@/pages/Invoices';
import { Repairs } from '@/pages/Repairs';
import { RMAs } from '@/pages/RMAs';
import { GRNs } from '@/pages/GRNs';
import { Suppliers } from '@/pages/Suppliers';
import { RMAReplacementLog } from '@/pages/RMAReplacementLog';
import { Users } from '@/pages/Users';
import { Blacklist } from '@/pages/Blacklist';
import { Activity } from '@/pages/Activity';
import { Settings } from '@/pages/Settings';
import { Reports } from '@/pages/Reports';
import { CreditNotes } from '@/pages/CreditNotes';
import { Quotations } from '@/pages/Quotations';
import { Expenses } from '@/pages/Expenses';
import { Builds } from '@/pages/Builds';
import { DealerCredit } from '@/pages/DealerCredit';
import { SerialLookup } from '@/pages/SerialLookup';
import '@/App.css';

const AppContent = () => {
  const { user, loading } = useAuth();
  const [activeTab, setActiveTab] = useState('dashboard');

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-xl text-gray-600 dark:text-gray-400">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard onNavigate={setActiveTab} />;
      case 'products':
        return <Products />;
      case 'customers':
        return <Customers />;
      case 'invoices':
        return <Invoices />;
      case 'repairs':
        return <Repairs />;
      case 'rmas':
        return <RMAs />;
      case 'builds':
        return <Builds />;
      case 'dealer-credit':
        return <DealerCredit />;
      case 'serial-lookup':
        return <SerialLookup />;
      case 'credit-notes':
        return <CreditNotes />;
      case 'expenses':
        return <Expenses />;
      case 'quotations':
        return <Quotations />;
      case 'grns':
        return <GRNs />;
      case 'suppliers':
        return <Suppliers />;
      case 'rma-replacement-log':
        return <RMAReplacementLog />;
      case 'users':
        return <Users />;
      case 'blacklist':
        return <Blacklist />;
      case 'activity':
        return <Activity />;
      case 'settings':
        return <Settings />;
      case 'reports':
        return <Reports />;
      default:
        return <Dashboard onNavigate={setActiveTab} />;
    }
  };

  return (
    <Layout activeTab={activeTab} onTabChange={setActiveTab}>
      {renderContent()}
    </Layout>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
